import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataResult, DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { delay, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InboxListPaginationService extends Subject<DataStateChangeEventArgs> {
  private BASE_URL = '/CompanyUserSystemMessageAssoc';
  constructor(private http: HttpClient) {
    super();
  }
  public execute(state: any, companyId: any): void {
    this.getData(state, companyId).subscribe((x) => super.next(x));
  }

  protected getData(
    state: DataStateChangeEventArgs,
    companyId: any
  ): Observable<DataStateChangeEventArgs> {
    const pageQuery = `skip=${state.skip}&top=${state.take}`;
    const sortQuery = '';
    let searchQuery = '';
    if (state.search || [].length) {
               searchQuery = `&query=${state.search}`;
        }else{
          searchQuery = `&query=`;
     }

    if(companyId || companyId!=null){
      searchQuery += `&CompanyID=${companyId}`;
     }

    return this.http
        .get(
            `${this.BASE_URL
            }?${pageQuery}${searchQuery}`
        )
        .pipe(
            map(
                (response: any) =>
                    <DataResult>{
                        result: response.Data,
                        count:response.TotalItems
                      }
            ),
        )
        .pipe((data: any) => data);
  }


public executeSorting(state: any, companyId: any, sortType: any, columnNameToSort: any, isDescSort: boolean): void {
  this.getDataBySorting(state, companyId,  sortType, columnNameToSort, isDescSort).subscribe((x) => super.next(x));
}

protected getDataBySorting(
  state: DataStateChangeEventArgs,
  companyId: any,
  sortType: any,
  columnNameToSort: any,
  isDescSort: boolean
): Observable<DataStateChangeEventArgs> {
  const pageQuery = `skip=${state.skip}&top=${state.take}`;
  let sortQuery = '';
  let searchQuery = '';
  sortType = isDescSort ? 'desc' : '';
  const descSortAndSortType: string = '&orderby=' + sortType + '&sortcolumn=' + columnNameToSort;
  const SortAndSortType: string = '&sortcolumn=' + columnNameToSort;
  sortQuery = isDescSort ? descSortAndSortType : SortAndSortType;
  if (state.search || [].length) {
      searchQuery = `&query=${state.search}`;
     } else {
    searchQuery = `&query=`;
  }
  if (companyId || companyId != null) {
    searchQuery += `&companyId=${companyId}`;
  }

  return this.http
    .get(`${this.BASE_URL}?${pageQuery}${searchQuery}${sortQuery}`)
    .pipe(
      map(
        (response: any) =>
          <DataResult>{
            result: response.Data,
            count: response.TotalItems,

          }
      ),
    )
    .pipe((data: any) => data);
  }


}
